(function () {
  'use strict';
  angular
    .module('com.module.gradingschemes')
    .run(function ($rootScope, gettextCatalog) {
        
    });

})();
